import apolloClient from 'apollo-client'
import {
  GET_INVENTORY_LIST,
  ADD_INVENTORIES,
  ADD_INVENTORY,
  GET_INVENTORY_NOTES,
  REMOVE_INVENTORIES,
  UPDATE_INVENTORY,
  UPDATE_INVENTORIES,
  REMOVE_INVENTORY,
  GET_LOCATIONS,
} from './graphql'

class InventoryService {
  async list(params: any) {
    const variables: any = {...params}
    if (params.locations && params.locations.length > 0) {
      variables.locationIds = params.locations.map((location: any) => location.id)
    }
    const {data} = await apolloClient.query({
      query: GET_INVENTORY_LIST,
      variables,
    })

    return {data: data.searchInventories.nodes, totalCount: data.searchInventories.totalCount}
  }

  async locationList() {
    const {data} = await apolloClient.query({
      query: GET_LOCATIONS,
    })
    return {data: data.locations.nodes}
  }

  async add(AddInventoryInput: any) {
    return apolloClient.mutate({
      mutation: ADD_INVENTORY,
      variables: {input: AddInventoryInput},
    })
  }
  async update(params: any) {
    const value = {
      availableQuantity: params.quantity,
      pInventoryItemId: params.pInventoryItemId,
      description: params.description,
      originalQuantity: params.originalQuantity,
      action: params.action,
      pLocationId: params.pLocationId,
    }
    return apolloClient.mutate({
      mutation: UPDATE_INVENTORY,
      variables: {input: value},
    })
  }
  async remove(RemoveInventoryInput: any) {
    return apolloClient.mutate({
      mutation: REMOVE_INVENTORY,
      variables: {input: RemoveInventoryInput},
    })
  }

  async notesList(filter: any) {
    const {data} = await apolloClient.query({
      query: GET_INVENTORY_NOTES,
      variables: {
        inventoryItemId: filter.notesId,
        first: filter.pageSize,
        offset: filter.offset,
      },
    })
    return {data: data.inventoryNotes.nodes, totalCount: data.inventoryNotes.totalCount}
  }

  async addInventories(params: any) {
    return apolloClient.mutate({
      mutation: ADD_INVENTORIES,
      variables: {input: params},
    })
  }

  async removeInventories(params: any) {
    return apolloClient.mutate({
      mutation: REMOVE_INVENTORIES,
      variables: {input: params},
    })
  }
  async updateInventories(params: any) {
    return apolloClient.mutate({
      mutation: UPDATE_INVENTORIES,
      variables: {input: params},
    })
  }
}

const inventoryService = new InventoryService()
export default inventoryService
